/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Author/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Author({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/More/Audit/Content/Main/Content/Entry/Author"
  
}) {
let entryCreatedByValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'created_by',
format: fromFormat.personName,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="entry.created_by"
 format="/Data/format.js personName"
 text={entryCreatedByValueData}
 weight="semibold"
/>
{children}
</React.Fragment>)
}